import React from 'react';
import { Heading, Slide } from 'spectacle-ppa';

function balloonSlide ({
  id,
  balloonType,
  questionNumber,
  numQuestions,
  notes,
  heading,
  characterImage,
  characterSide,
  bgColor,
  html,
  slideClass
}) {
  const charPos = characterSide !== '' ? characterSide : '';
  const slideContentClass = slideClass ? ' slide-' + slideClass : '';
  const balloonClass = !balloonType && !bgColor ? ' balloon-regular' : '';
  const bgColorOpts = {};
  if (bgColor) {
    bgColorOpts.bgColor = bgColor;
  } else {
    if (balloonType) {
      bgColorOpts.bgColor = balloonType === 'question' ? '#45B3EC' : '#6FC36E'; // set to 45B3EC for questions, 6FC36E for other non-empty values
    } else {
      bgColorOpts.bgColor = 'transparent';
    }
  }
  return (
    <Slide
        id={id}
        key={id}
        {...bgColorOpts}
        notes={notes}>
      <div className={'slide-content' + slideContentClass}>
        <div
          className={'text-balloon ' + charPos + ' text-formatted' + balloonClass }>

          { balloonType === 'question' ?
            <Heading size={2}>
              {'Question '}
              {questionNumber}
              {' of '}
              {numQuestions}:
            </Heading>
            : null
          }
          { !!heading &&
            <Heading size={3}>
              {heading}
            </Heading>
          }
          <div
              className="text-balloon-body"
              dangerouslySetInnerHTML={{__html: html}} />

        </div>
      { characterImage ?
        <div
            className={'text-balloon-character ' + charPos}>
          <img src={characterImage} />
        </div>
        : null
      }
      </div>
    </Slide>
  );
}

export default balloonSlide;



// WEBPACK FOOTER //
// ./programs/keepCool/baseSlides/balloonSlide.js